import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class OnlineResMgr extends Base {
  // 获取线上资源列表
  public static getOnlineResList(option, page) {
    const param = {
      classify: option.classifyValue,
      deviceName: option.deviceName,
      serialNumber: option.serialNumber,
      status: option.statusValue,
      slot: option.slot,
      pid: option.pid,
      provinceId: option.vprovinceValue,
      manufacturer: option.manufacturerValue,
      currPage: page.currPage,
      pageSize: page.size
    };
    return request.get(`/api/resource/online/list`, {
      params: param
    });
  }
  // 获取线上资源对象通过ID
  public static getCurrentOnlineResData(id: string) {
    return request.get(`/api/resource/:id`);
  }
}
